
export const ANOUN_LIST_REQUEST = "csboard/ANOUN_LIST_REQUEST";
export const ANOUN_LIST_SUCCESS = "csboard/ANOUN_LIST_SUCCESS";
export const ANOUN_LIST_FAILURE = "csboard/ANOUN_LIST_FAILURE";

export const ANOUN_DETAILED_REQUEST = "csboard/ANOUN_DETAILED_REQUEST";
export const ANOUN_DETAILED_SUCCESS = "csboard/ANOUN_DETAILED_SUCCESS";
export const ANOUN_DETAILED_FAILURE = "csboard/ANOUN_DETAILED_FAILURE";

export const FAQ_LIST_REQUEST = "csboard/FAQ_LIST_REQUEST";
export const FAQ_LIST_SUCCESS = "csboard/FAQ_LIST_SUCCESS";
export const FAQ_LIST_FAILURE = "csboard/FAQ_LIST_FAILURE";

export const MTRL_FILE_REQUEST = "csboard/MTRL_FILE_REQUEST";
export const MTRL_FILE_SUCCESS = "csboard/MTRL_FILE_SUCCESS";
export const MTRL_FILE_FAILURE = "csboard/MTRL_FILE_FAILURE";

export const MTRL_CONDITION_REQUEST = "csboard/MTRL_CONDITION_REQUEST";
export const MTRL_CONDITION_SUCCESS = "csboard/MTRL_CONDITION_SUCCESS";
export const MTRL_CONDITION_FAILURE = "csboard/MTRL_CONDITION_FAILURE";

export const MTRL_LIST_REQUEST = "csboard/MTRL_LIST_REQUEST";
export const MTRL_LIST_SUCCESS = "csboard/MTRL_LIST_SUCCESS";
export const MTRL_LIST_FAILURE = "csboard/MTRL_LIST_FAILURE";

export const TERMS_CONDITIONS_REQUEST = "csboard/TERMS_CONDITIONS_REQUEST";
export const TERMS_CONDITIONS_SUCCESS = "csboard/TERMS_CONDITIONS_SUCCESS";
export const TERMS_CONDITIONS_FAILURE = "csboard/TERMS_CONDITIONS_FAILURE";

export const NIMPT_ANOUNALL_REQUEST = "csboard/NIMPT_ANOUNALL_REQUEST";
export const NIMPT_ANOUNALL_SUCCESS = "csboard/NIMPT_ANOUNALL_SUCCESS";
export const NIMPT_ANOUNALL_FAILURE = "csboard/NIMPT_ANOUNALL_FAILURE";

export const GO_ANOUN_LIST = "csboard/GO_ANOUN_LIST";

export const ANOUN_ARRAY_PASS = "csboard/ANOUN_ARRAY_PASS";

export const SET_PAGE_RELOAD = "csboard/SET_PAGE_RELOAD"